var _style, _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0 {\n\t\t\tfill: #327DFF;\n\t\t}\n\n\t\t.st1 {\n\t\t\tfill: #FFFFFF;\n\t\t}\n\t")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.2,12.2l3.6-3.6l0.7-0.7c0.1-0.1,0.1-0.3,0-0.4l-0.8-0.8c-0.1-0.1-0.3-0.1-0.4,0L12,11.1L7.6,6.7 c-0.1-0.1-0.3-0.1-0.4,0L6.4,7.5c-0.1,0.1-0.1,0.3,0,0.4l4.4,4.3l-4.4,4.4c-0.1,0.1-0.1,0.3,0,0.4l0.8,0.8c0.1,0.1,0.3,0.1,0.4,0 l4.4-4.4l3.6,3.6l0.7,0.7c0.1,0.1,0.3,0.1,0.4,0l0.8-0.8c0.1-0.1,0.1-0.3,0-0.4L13.2,12.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/Replace.431fb83bb48a1c24bec74eca5f765b40.svg";
export { ForwardRef as ReactComponent };